import type {
  UpsertRelatedPeopleDetailsPayload,
  UpsertRelatedPeopleDetailsResult,
} from '@shared/services/caregivers/types/updateRelatedPeopleDetails.types';
import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { ADD_RELATED_PERSON } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

export const addRelatedPerson = (builder: BuilderType) =>
  builder.mutation<UpsertRelatedPeopleDetailsResult, UpsertRelatedPeopleDetailsPayload>({
    query: (body) => ({
      data: body,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: ADD_RELATED_PERSON,
    }),
    transformResponse: (response: GenericApiResponse<UpsertRelatedPeopleDetailsResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
